// Class toggled on <body> to force the mouse cursor visible (and clickable-looking) even while
// gameplay's "hide-cursor" rule is active (see gearshiftGame/styles/cursor.css). Used by any overlay/
// prompt the experimenter needs to see and click mid-gameplay (TTL reconnect badge, fullscreen
// restore prompt, etc).
const CURSOR_VISIBLE_CLASS = "cursor-visible-override";

// Multiple overlays can independently need the cursor visible at once (e.g. the TTL badge and
// the fullscreen restore prompt, both up at the same time). Track requesters by id instead of a
// plain on/off toggle, so one overlay dismissing itself doesn't yank the cursor away from another.
const activeRequesters = new Set();

/** @param {string} requesterId Unique id for the caller (e.g. "ttlBadge", "fullscreenPrompt") */
export function showCursor(requesterId) {
  activeRequesters.add(requesterId);
  document.body.classList.add(CURSOR_VISIBLE_CLASS);
}

/** @param {string} requesterId The same id passed to the matching showCursor() call */
export function restoreCursor(requesterId) {
  activeRequesters.delete(requesterId);
  if (activeRequesters.size === 0) {
    document.body.classList.remove(CURSOR_VISIBLE_CLASS);
  }
}

/** Hard reset for game start/end - clears every requester and the class, regardless of who set it. */
export function resetCursorVisibility() {
  activeRequesters.clear();
  document.body.classList.remove(CURSOR_VISIBLE_CLASS);
}
